module.exports = __webpack_public_path__ + "img/no-winner.6d447b7f.png";